const regulateNumberOfDownloads = listOfTransformedImages => {
  if (listOfTransformedImages.length <= 1000) return 1;
  return Math.ceil(listOfTransformedImages.length / 1000);
};

export default regulateNumberOfDownloads;
